<template>
  <div>
    <nav v-if="true" class="navbar-default navbar-static-side">
      <div class="sidebar-collapse">
        <div class="logo-element">KP+</div>
      </div>
      <ul side-navigation class="nav metismenu" id="side-menu">
        <li
          ui-sref-active="active"
          :class="{'active':liIndex==menuIndex && menu.children}"
          v-for="(menu,menuIndex) in functionList"
          :key="menuIndex"
          @click.stop="showList(menu.funcName,menuIndex)"
        >
          <a v-if="menu.children" ui-sref="layouts">
            <i class="fa" :class="menu.icon"></i>
            <span class="nav-label">{{$t(("message."+menu.funcName)) }}</span>
            <span class="fa arrow"></span>
          </a>
          <a v-if="!menu.children" ui-sref="layouts" @click="gotoUrl(menu.webInfo,[menu.funcName])">
            <i class="fa" :class="true?menu.icon:''"></i>
            <span class="nav-label">{{$t(("message."+menu.funcName)) }}</span>
          </a>
          <ul
            v-if="menu.children"
            class="nav nav-second-level collapse"
            :class="{in: activeName==menu.funcName}"
            :style="activeName==menu.funcName?styleHeight:'height:0'"
          >
            <li
              ui-sref-active="active"
              v-for="(menu2item,menu2itemIndex) in menu.children"
              :key="menu2itemIndex"
            >
              <a
                @click.stop="gotoUrl(menu2item.webInfo,[menu.funcName,menu2item.funcName])"
                v-if="!menu2item.children"
              >
                {{ $t(("message."+menu2item.funcName)) }}
                <span
                  class="label label-warning pull-right"
                  v-if="menu2item.funcCode == 'INBOX'"
                >form.getNotificationNum</span>
              </a>
              <a href v-if="menu2item.children">
                {{ $t(("message."+menu2item.funcName)) }}
                <span class="fa arrow"></span>
              </a>
              <ul class="nav nav-third-level">
                <li v-for="(menu3item,menu3itemIndex) in menu2item.children" :key="menu3itemIndex">
                  <a
                    @click.stop="gotoUrl(menu3item.webInfo,[menu.funcName,menu2item.funcName,menu3item.funcName])"
                  >{{ $t(("message."+menu3item.funcName)) }}</a>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</template>
<script>
import broadcast from "../../lib/broadcast.js";

export default {
  name: "navigationController",
  data() {
    return {
      activeName: "",
      liIndex: null,
      ctrlActive: false,
      styleHeight: {
        height: "auto !important"
      },
      positionIndex: []
    };
  },
  methods: {
    gotoUrl(webInfo, indexArr) {
      this.positionIndex = indexArr;
      //;
      // this.$router.push({ path: webInfo });
      if (webInfo.indexOf("footerAcknowledgement") != -1) {
        this.$router.push({
          path: "footerPage",
          query: { paeType: "acknowledgement" }
        });
      } else if (webInfo.indexOf("footerCopAndDis") != -1) {
        this.$router.push({
          path: "footerPage",
          query: { paeType: "copyrightNoticeDisclaimer" }
        });
      } else if (webInfo.indexOf("footerPrivacy") != -1) {
        this.$router.push({
          path: "footerPage",
          query: { paeType: "privacyPolicy" }
        });
      } else if (webInfo.indexOf("footerAccessibility") != -1) {
        this.$router.push({
          path: "footerPage",
          query: { paeType: "accessibility" }
        });
      } else if (webInfo.indexOf("footerReserved") != -1) {
        this.$router.push({
          path: "footerPage",
          query: { paeType: "allRightsReserved" }
        });
      } else {
        this.$router.push({ path: webInfo });
      }

      this.emitIndex();
    },
    showList(funcName, liIndex) {
      if (funcName === this.activeName) {
        this.activeName = undefined;
        this.liIndex = undefined;
      } else {
        this.activeName = funcName;
        this.liIndex = liIndex;
      }
    },
    emitIndex() {
      broadcast.$emit("getIndex", this.positionIndex);
    }
  },
  computed: {
    functionList() {
      return this.$store.state.userInfo.systemFuncs;
    }
  },
  mounted: function() {}
};
</script>
